import stacyOnTableArousedBG from'../images/stacyOnTableArousedBG.png'
import stacyOnTableArousedRightBG from'../images/stacyOnTableArousedRightBG.png'
import stacyOnTableArousedLeftBG from'../images/stacyOnTableArousedLeftBG.png'
import stacyOnTableUnarousedLeftBG from'../images/stacyOnTableUnarousedLeftBG.png'
import stacyOnTableUnarousedRightBG from'../images/stacyOnTableUnarousedRightBG.png'
import stacyOnTableUnarousedBG from'../images/stacyOnTableUnarousedBG.png'
import classroomMainCutAfterOrgasm from'../images/classroomMainCutAfterOrgasm.png'
import classroomMainSlide6_bg from'../images/classroomMainSlide6_bg.png'
import classroomTables_bg from'../images/classroomTables_bg.png'
import stacyAfterOrgasm from'../images/stacyAfterOrgasm.png'
import stacyGettingNaked from'../images/stacyGettingNaked.png'
import wipingDeskBG from'../images/wipingDeskBG.gif'
import stacyClitorisQuestion from'../images/stacyClitorisQuestion.gif'
import stacyClitorisQuestionBG from'../images/stacyClitorisQuestionBG.png'
import stacyTouchingTits from'../images/stacyTouchingTits.gif'
import stacyButtPetting from'../images/stacyButtPetting.gif'
import stacyTeachMasturbation1 from'../images/stacyTeachMasturbation1.png'
import stacyTeachMasturbation2 from'../images/stacyTeachMasturbation2.gif'
import stacyTeachMasturbation3 from'../images/stacyTeachMasturbation3.png'
import ryderInsta from'../images/ryderInsta.png'
import willieChat from'../images/willieChat.png'
import howardChat from'../images/howardChat.png'
import stacyChat from'../images/stacyChat.png'
import phoebeChat from'../images/phoebeChat.png'
import chatCover from'../images/chatCover.png'
import characters from'./characters';
import achievements from'./achievements';
import gallery from'./gallery';
import classroomAbmient from'../m/classroomAbmient.js'
import classIntro from'../m/classIntro.js'
import doorOpen from'../m/doorOpen.js'
import almostCrying from'../m/almostCrying.js'
import crying from'../m/crying.js'
import yay from'../m/yay.js'
import darkPlayful from'../m/darkPlayful.js'
import crowdWow from'../m/crowdWow.js'
import vinyl from'../m/vinyl.js'
import whoosh from'../m/whoosh.js'
import study from'../m/study.js'
import screamHoward from'../m/screamHoward.js'
import quiz from'../m/quiz.js'
import sexyJazz from'../m/sexyJazz.js'
import waiting from'../m/waiting.js'
import femaleMoaning7 from'../m/moansStacy/femaleMoaning7.js'
import bellRinging from'../m/bellRinging.js'
import boner from'../m/boner.js'
import indoorCrowd from'../m/indoorCrowd.js'

const chapter2ru = [

  {novel:true, background:classroomMainSlide6_bg, startCoordinates:40,
  script:[
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1.5,
    phrases:[
      {text:"Ну что ж, ребята, время вышло! Передавайте мне тесты и давайте приступать к практике", emotion:characters["profryder"].standingEyebrowsUp, ambientStart:classroomAbmient, loopTimeAmbient:500, ambientSettings:[0.5, 1200], musicStart:classIntro, loopTime:30000, musicSettings:[0.2, 2200]},
      {text:"Сегодня попробуем разбирать женский оргазм и петтинг.", emotion:characters["profryder"].standingNeutral},
      {text:"Для этого мне потребуются 2 волонтера...", emotion:characters["profryder"].standingNeutral},
      {text:"Но, должна предупредить, сегодняшняя активность будет довольно мм... откровенной", emotion:characters["profryder"].standingLaughing},
      {text:"Так что, кто-нибудь хочет поучаствовать?", emotion:characters["profryder"].standingQuestion},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1.3,
    phrases:[
      {text:"Здрав... Здравствуйте...", emotion:characters["violet"].shy, soundEffectPre:doorOpen, soundEffectVolume:0.5},
      {text:"Извините за опоздание.", emotion:characters["violet"].shyEyesDown},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"Добрый день! Ничего страшного", emotion:characters["profryder"].standingSmiling},
      {text:"Только, пожалуйста, не забудь посмотреть презентацию по теории дома", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"И написать тест на следующем занятии", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Хотя, у тебя с собой так много книг.. ты, наверное, сама смогла бы преподавать, хаха", emotion:characters["profryder"].standingLaughing},
      {text:"Что это тут у тебя?", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"‘Она кончает первой’, ооо даа, очень рекомендую!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1,
    phrases:[
      {text:"К-конечно, я напишу тест..", emotion:characters["violet"].shyEyesDown},
      {text:"Я могу садиться?", emotion:characters["violet"].neutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"Да-да...А хотя стой, может, хочешь поучавствовать?", emotion:characters["profryder"].standingSmiling},
      {text:"Я как раз ищу волонтеров", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1,
    phrases:[
      {text:"Ой, аа.. эм..", emotion:characters["violet"].shyEyesDown},
      {text:"Я даже не знаю..", emotion:characters["violet"].shy},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"Или пока понаблюдаешь?", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {char:characters["violet"],  position:"left", coordinates: 40, speed:1,
    phrases:[
      {text:"Мм, да", emotion:characters["violet"].shy},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1,
    phrases:[
      {text:"Хорошо.", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Хммм", emotion:characters["profryder"].standingQuestion},
      {text:"Фиби, может, ты?", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {endOfNovel:true, musicContinue:true}
  ]
  },

  {novel:true, background:classroomTables_bg, startCoordinates:20,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, loopTimeAmbient:500, ambientSettings:[0.5, 1200], musicStart:classIntro, loopTime:30000, musicSettings:[0.2, 2200]},
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:0.4,
    phrases:[
      {text:"Я?", emotion:characters["phoebe"].sittingSurprisedCoffee, ambientStart:classroomAbmient, loopTimeAmbient:500, ambientSettings:[0.5, 1200]},
      {text:"Не знаю. Я бы лучше...", emotion:characters["phoebe"].sittingThinkingBlushedCoffee},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Уверенна, у тебя все получится!", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Давай-давай, ну же, будет весело!!", emotion:characters["willie"].sittingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Я не...", emotion:characters["phoebe"].sittingQuestionCoffee},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Она всегда была трусихой", emotion:characters["ursula"].sittingDisgusted},
    ]
    },
    {char:characters["everyone"],  position:"center", coordinates: 5, speed:0.7,
    phrases:[
      {text:"Фиби! Фиби!", musicEnd:true, musicSettings:300, soundEffect:yay, soundEffectVolume:0.3},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Я... Я...", emotion:characters["phoebe"].sittingSadTearsCoffee, answers:["Заступиться", "Фиби! Фиби!"], soundEffect:almostCrying, soundEffectVolume:0.5, musicStart:darkPlayful, loopTime:10000, musicSettings:[0.1, 2200]},
    ]
    },
    {option:"Заступиться", start:true},
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Хватит на нее давить!", emotion:characters["dick"].sittingAngry, achievement:achievements[7]},
      {text:"Она же сказала, что не хочет!", emotion:characters["dick"].sittingAngry},
      {text:"Разве этого недостаточно?!", emotion:characters["dick"].sittingAngry},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"<small><i>Похоже у сестрички появился защитничек хаха</small></i>", emotion:characters["ursula"].sittingWhatever},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Ричард, ты абсолютно прав, этого достаточно!", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Спасибо...", emotion:characters["phoebe"].sittingSadCoffee, soundEffect:crying, soundEffectVolume:0.2},
    ]
    },
    {option:"Заступиться", endOfOption:true},

    {option:"Фиби! Фиби!", start:true},
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Фиби, Фиби!", emotion:characters["dick"].sittingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Да хватит на меня давить!", emotion:characters["phoebe"].sittingAngryTearsCoffee},
      {text:"Я же сказала, что не готова!", emotion:characters["phoebe"].sittingAngryTearsCoffee},
      {text:"Боже, неужели так сложно просто меня услышать?", emotion:characters["phoebe"].sittingFrustratedTearsCoffee},
      {text:"Я ПРОСТО не хочу!", emotion:characters["phoebe"].sittingAngryTearsCoffee},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Фиби, прошу прощения. Я.. должна была остановить это раньше.", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Оставьте... Просто не трогайте меня!", emotion:characters["phoebe"].sittingFrustratedTearsCoffee, soundEffect:crying, soundEffectVolume:0.4},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Да, конечно", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {option:"Фиби! Фиби!", endOfOption:true, endOfOptions:true},

    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Ребята, вот правило которому я всегда следую", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"И особенно это важно в сексе", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Если кто-то чего-то не хочет, не заставляйте их это делать.", emotion:characters["profryder"].standingNeutral},
    ]
    },
    {char:characters["howard"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"А если она делает это всё только для того, чтобы унизить меня, лишить меня моих базовых потребностей?", emotion:characters["howard"].sittingNeutral},
      {text:"Что если она просто изображает недотрогу?", emotion:characters["howard"].sittingNeutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Ох, Говард, понимаю, чувствовать себя отвергнутым - это и правда может ранить", emotion:characters["profryder"].standingNeutral},
      {text:"Но близость - не то, что кто-то кому-то должен", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Близость - это про взаимное уважение и доверие", emotion:characters["profryder"].standingSmiling},
      {text:"И часто получается, что этого трудно достичь, ведь мы все очень разные", emotion:characters["profryder"].standingSmiling},
      {text:"Но восприятие таких вещей как обязанности, лишь вредит обоим партнерам", emotion:characters["profryder"].standingEyebrowsUp},
      {text:'Поэтому когда человек говорит тебе "нет" - это просто "нет". Мы должны уважать это вне зависимости от причины', emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Блин, Фиби, прости, я просто... хотел тебя поддержать", emotion:characters["willie"].sittingSerious, musicEnd:true, musicSettings:800},
      {text:"Надо было перестать, когда ты отказалась...", emotion:characters["willie"].sittingSerious},
    ]
    },
    {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"Да, ладно, проехали", emotion:characters["phoebe"].sittingNeutralCoffee},
      {text:"Кстати, ты хорошо.. извиняешься, чувак", emotion:characters["phoebe"].sittingSmilingCoffee},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Так, на чем мы остановились? Ах, да", emotion:characters["profryder"].standingQuestion, musicStart:classIntro, loopTime:30000, musicSettings:[0.2, 2200]},
      {text:"Мне все еще нужны люди на практику!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["empty"],  position:"center", coordinates: 10, speed:1,
    phrases:[
      {text:"*Тишина*"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Ребята, ну не заставляй меня делать все самой... Важно, чтобы вы получили реальный опыт!", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"<small><i>Похоже, придется спасать этих лошков самой</small></i>", emotion:characters["ursula"].sittingWhatever},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Я хочу!", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["ursula"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Мда, нимфоманка..", emotion:characters["ursula"].sittingNeutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Стейси, учти, что тебе нужно будет снять все что ниже пояса...", emotion:characters["profryder"].standingBlushed},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Это легко...", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"И-и-и еще тебе нужен будет партнер, можешь выбрать его сама", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Кто-то, с кем ты сможешь почувствовать себя комфортно и безопасно", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["howard"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Я! Я!  Меня!", emotion:characters["howard"].sittingSnide},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Хмм. безопасно...", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"<small><i>Дик, вечером в фортик?</small></i>", emotion:characters["willie"].sittingSnide},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"<small><i>Естественно</small></i>", emotion:characters["dick"].sittingNeutral},
    ]
    },
    {char:characters["stacy"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"Дик!", emotion:characters["stacy"].sittingNeutral},
      {text:"Дик, ты хочешь ко мне присоединиться?", emotion:characters["stacy"].sittingNeutral},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"<small><i>Че? Не слышу</small></i>", emotion:characters["willie"].sittingSnide},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 0, speed:1,
    phrases:[
      {text:"ДАА!", emotion:characters["dick"].sittingNeutral, musicEnd:true, musicSettings:200, soundEffect:vinyl, soundEffectVolume:0.3},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 10, speed:1,
    phrases:[
      {text:"ВОТ ЭТО рвение", emotion:characters["profryder"].standingLaughing},
      {text:"Хорошо, Стейси, можешь пока готовиться", emotion:characters["profryder"].standingSmiling},
      {text:"А, и еще, важно, чтобы ваши руки были чистыми, можете взять влажные салфетки в моем ящике", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {scene:true, img:stacyGettingNaked, start:true, time:300, gallery:gallery[11], soundEffectPre:crowdWow, soundEffectVolume:0.3},
    {scene:true, name:characters["empty"].nameRu, position:"center",
    phrases:[
      {text:"О боже... Я что, буду ее трогать.. ТАМ?!"}
    ]},
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {endOfNovel:true, musicContinue:true}
  ]
  },

  {novel:true, background:stacyOnTableUnarousedRightBG, startCoordinates:20,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, gallery:gallery[12]},
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Только посмотрите на эту сладкую писеч...", emotion:characters["profryder"].standingBlushed, ambientStart:classroomAbmient, loopTimeAmbient:500, ambientSettings:[0.3, 1200], musicStart:study, loopTime:30000, musicSettings:[0.2, 3000]},
      {text:"То есть... эм-м.. прекрасная вульва!", emotion:characters["profryder"].standingLaughing},
      {text:"Такс, ну давайте начнем с клитора", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Ричард, сможешь показать где он находится?", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {scene:true, img:stacyClitorisQuestion, img2:stacyClitorisQuestionBG, start:true, time:300, dialogCoordinates:"78vh", gallery:gallery[13], musicChangeSettings:[0.05, 500]},
    {scene:true, name:characters["dick"].nameRu, position:"left",
    phrases:[
      {text:"Он..", answers:["Первый вариант", "Второй вариант", "Третий вариант"], soundEffectPre:quiz, soundEffectVolume:0.3},
    ]},
    {option:"Первый вариант", start:true},
    {scene:true, name:characters["profryder"].nameRu, position:"right", dialogCoordinates:"60vh",
    phrases:[
      {text:"Почти, это капюшон клитора, который его закрывает", achievement:achievements[8], musicChangeSettings:[0.2, 3000], soundEffectEnd:true, effectSettings:2000},
      {text:"Не волнуйся, тут легко запутаться, клитор совсем рядом"},
    ]},
    {option:"Первый вариант", endOfOption:true},

    {option:"Второй вариант", start:true},
    {scene:true, name:characters["profryder"].nameRu, position:"right", dialogCoordinates:"60vh",
    phrases:[
      {text:"Да, ты прав!", achievement:achievements[9], musicChangeSettings:[0.2, 3000], soundEffectEnd:true, effectSettings:2000},
      {text:"Молодец!"},
    ]},
    {option:"Второй вариант", endOfOption:true},

    {option:"Третий вариант", start:true},
    {scene:true, name:characters["profryder"].nameRu, position:"right", dialogCoordinates:"60vh",
    phrases:[
      {text:"Это уретра, клитор немного выше", achievement:achievements[8], musicChangeSettings:[0.2, 3000], soundEffectEnd:true, effectSettings:2000},
      {text:"Не волнуйся, иногда его непросто найти"},
    ]},
    {option:"Третий вариант", endOfOption:true, endOfOptions:true},
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, soundEffectPre:whoosh, soundEffectVolume:0.3},

    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Как вы все уже знаете, клитор ответственнен за...", emotion:characters["profryder"].standingEyebrowsUp},
    ]
    },
    {char:characters["willie"],  position:"center", coordinates: 70, speed:1,
    phrases:[
      {text:"Женский оргазм!"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Умница!", emotion:characters["profryder"].standingLaughing},
      {text:"И в отличие от мужского, он гораздо сильнее зависит от физиологического и психологического состояния", emotion:characters["profryder"].standingSmiling},
      {text:"Не смотря на то, что показывают нам в порно, женщина не всегда может получить оргазм и это нормально", emotion:characters["profryder"].standingSmiling},
      {text:"Чтобы все получилось, девушке и ее партнеру или партнерке иногда приходится изрядно попотеть хаха", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["howard"],  position:"center", coordinates: 70, speed:1,
    phrases:[
      {text:"Если не получилось, значит, плохо ебались!!", soundEffectPre:screamHoward},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Говард, опять же, это не так", emotion:characters["profryder"].standingNeutral},
      {text:"Достичь оргазма бывает сложно по разным причинам", emotion:characters["profryder"].standingNeutral},
      {text:"Тревожность, проблемы в коммуникации, использование чересчур стимулирующего метода мастурбации в прошлом", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Вообще говоря, столкновение с такими проблемами, в конечном счете, и привели меня сюда, помогать вам!", emotion:characters["profryder"].standingLaughing},
	  {text:"А иногда женщина вообще не ощущают отсутствие оргазма проблемой и это тоже нормально! Оргарзм не обязательно должен быть целью", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Но если кого-то из вас это волнует, не переживайте, есть много путей, которые могут вам помочь!", emotion:characters["profryder"].standingNeutral},
      {text:"Точно не стоит винить во всем себя или пытаться симулировать оргазм", emotion:characters["profryder"].standingSmiling},
      {text:"В сексе очень важно, чтобы все участники чувствовали себя хорошо и могли свободно общаться", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Это и есть ключ к удовольствию: говорить о том, что вам нравится и как, направлять партнера", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Хорошо, если они, в свою очередь, стараются быть чуткими и внимательными", emotion:characters["profryder"].standingSmiling},
      {text:"Ладно, вижу, вы больше не моежете ждать, так что начнем!", emotion:characters["profryder"].standingLaughing},
      {text:"Для начала нам нужно будет возбудить Стейси", emotion:characters["profryder"].standingSmiling},
      {text:"Прелюдии очень важны многим женщинам, они позволяют расслабиться и настроиться на продолжение", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Стейси, скажи, как бы ты хотела начать?", emotion:characters["profryder"].standingSmiling},
      {text:"Что тебя возбуждает?", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
    phrases:[
      {text:"Ну.. Мне нравится, когда меня гладят по бедрам и животу..."},
      {text:"И еще... мм.. когда трогают мою грудь"},
    ]
  },
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableUnarousedLeftBG,
  phrases:[
    {text:"Ты не против, если я...", emotion:characters["dick"].neutral, answers:["Потрогаю твою грудь", "Поглажу твои бедра"], musicEnd:true, musicSettings:1000},
  ]
},
  {option:"Потрогаю твою грудь", start:true},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
phrases:[
  {text:"Ни капельки не против..."},
]
},
{scene:true, img:stacyTouchingTits, start:true, time:300, dialogCoordinates:"72vh", gallery:gallery[14], musicStart:sexyJazz, loopTime:15000, musicSettings:[0.3, 2200]},
{scene:true, name:characters["dick"].nameRu, position:"left",
phrases:[
  {text:"Вот так?", achievement:achievements[10]},
]},
{scene:true, name:characters["stacy"].nameRu, position:"center",
phrases:[
  {text:"Ммх-мммм.."},
  {text:"Да.. Вот так.."},
  {text:"Посмотри мне в глаза, пожалуйста.."},
  {text:"Ты такой нежный..."},
]},
{scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, dialogCoordinates:"60vh", soundEffect:whoosh, soundEffectVolume:0.5},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableUnarousedRightBG,
phrases:[
  {text:"Отлично, Стейси, продолжай направлять Ричарда", emotion:characters["profryder"].standingBlushed, musicChangeSettings:[0.1, 1000]},
]
},
  {option:"Потрогаю твою грудь", endOfOption:true},

  {option:"Поглажу твои бедра", start:true},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
  phrases:[
  {text:"Ни капельки не против..."},
  ]
  },
  {scene:true, img:stacyButtPetting, start:true, time:300, dialogCoordinates:"72vh", gallery:gallery[15], musicStart:sexyJazz, loopTime:15000, musicSettings:[0.3, 2200]},
  {scene:true, name:characters["dick"].nameRu, position:"left",
  phrases:[
    {text:"Вот так?", achievement:achievements[11]},
  ]},
  {scene:true, name:characters["stacy"].nameRu, position:"center",
  phrases:[
    {text:"Ах..."},
    {text:"Не совсем.."},
    {text:"Но, кажется, так мне тоже нравится"},
    {text:"Это возбуждает..."},
  ]},
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, dialogCoordinates:"60vh", soundEffect:whoosh, soundEffectVolume:0.5},
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableUnarousedRightBG,
  phrases:[
    {text:"Стейси, не стесняйся говорить о своих желаниях и направлять Ричарда", emotion:characters["profryder"].standingBlushed, musicChangeSettings:[0.1, 1000]},
  ]
  },
  {option:"Поглажу твои бедра", endOfOption:true, endOfOptions:true},

  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableUnarousedBG,
  phrases:[
    {text:"Угу.."},
  ]
},
  {changeBG:true, img:stacyTeachMasturbation1, smooth:true},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
  phrases:[
    {text:"Ээм... теперь можешь положить руку вот сюда"},
  ]
  },
  {changeBG:true, img:stacyTeachMasturbation2, smooth:true, gallery:gallery[16]},
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
  phrases:[
    {text:"И делать так.."},
  ]
},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Да, очень хорошо...", emotion:characters["profryder"].standingBlushed},
    {text:"Эммм...", emotion:characters["profryder"].standingBlushed},
    {text:"Ну что, Ричард, ты готов?", emotion:characters["profryder"].standingEyebrowsUp, answers:["Да я эксперт!", "Готов","Немного нервничаю..."], warning:"Выбор повлияет на<br/> уровень сложности", soundEffect:waiting, soundEffectVolume:0.5},
  ]
  },

  {option:"Да я эксперт!", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Да я эксперт!", emotion:characters["dick"].smiling},
  ]
},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
phrases:[
  {text:"Ого!", emotion:characters["profryder"].standingBlushed},
  {text:"Ну, тогда покажи что умеешь!", emotion:characters["profryder"].standingBlushed},
]
},

  {option:"Да я эксперт!", endOfOption:true},

  {option:"Готов", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Готов", emotion:characters["dick"].smiling},
  ]
},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
phrases:[
  {text:"Отлично!", emotion:characters["profryder"].standingSmiling},
  {text:"Тогда приступим!", emotion:characters["profryder"].standingSmiling},
]
},
  {option:"Готов", endOfOption:true},

  {option:"Немного нервничаю...", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"На самом деле, я немного волнуюсь...", emotion:characters["dick"].frustrated},
  ]
},
{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
phrases:[
  {text:"Понимаю", emotion:characters["profryder"].standingBlushed},
  {text:"Я тебе помогу", emotion:characters["profryder"].standingNeutral},
  {text:"Если станет некомфортно, мы сразу прекратим", emotion:characters["profryder"].standingNeutral},
]
},
  {option:"Немного нервничаю...", endOfOption:true, endOfOptions:true},

  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
  phrases:[
    {text:"Ммм", soundEffect:femaleMoaning7, soundEffectVolume:0.2},
    {text:"Ммх-ммм"},
    {text:"Вот так вот.."},
  ]
},

{char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Стейси, дашь Ричарду попробовать?", emotion:characters["profryder"].standingBlushed},
    {text:"Если тебе комфортно, конечно", emotion:characters["profryder"].standingBlushed},
  ]
  },

  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
    {text:"Ой, да, конечно.."},
    {text:"Я немного увлеклась.."},
  ]
},

{changeBG:true, img:stacyTeachMasturbation3, smooth:true, gallery:gallery[17]},

{char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
phrases:[
  {text:"Ты можешь потрогать меня здесь"},
]
},
    {endOfNovel:true}
  ]
  },


  {masturbationGame:true},


  //Не послушал
  {novel:true, background:stacyOnTableArousedRightBG, startCoordinates:20,
  script:[
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Ричард, постарайся сконцентрироваться на том, что говорит Стейси", emotion:characters["profryder"].standingEyebrowsUp, ambientStart:classroomAbmient, loopTimeAmbient:500, ambientSettings:[0.5, 1200]},
      {text:"Понимаю, в такой обстановке это может быть не просто, особенно когда это впервые", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Но получиться может только так...", emotion:characters["profryder"].standingSmiling},
      {text:"Иначе вам обоим вряд ли понравится этот опыт", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"А мы ведь хотим, чтобы вам обоим было приятно, правда?", emotion:characters["profryder"].standingSmiling},
      {text:"Если хочешь попробовать еще раз, спроси Стейси готова ли она", emotion:characters["profryder"].standingSmiling},
      {text:"Я помогу", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"...", emotion:characters["dick"].frustrated, answers:["Попробуем еще?", "Думаю, для первого раза хватит.."]},
    ]
  },

  {option:"Попробуем еще?", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Прости, я отвлекся…", emotion:characters["dick"].frustrated},
    {text:"Попробуем еще?", emotion:characters["dick"].frustrated},
  ]
  },
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
    {text:"Нууу"},
    {text:"Да, все нормально.. Я понимаю"},
    {text:"И вообще я и сама очень хочу попробовать еще раз"},
    {text:"<small><i>может, в этот раз...</small></i>", setNextStep:-1, lastTry:4},
    {text:"Но, знаешь, делать это слишком долго, мне становится больно"},
    {text:"Так что давай это будет последняя попытка, хорошо?", setNextStep:-1},
  ]
},
  {option:"Попробуем еще?", endOfOption:true},


  {option:"Думаю, для первого раза хватит..", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Думаю, для первого раза хватит..", emotion:characters["dick"].frustrated},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Понимаю", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Абсолютно нормально сделать перерыв", emotion:characters["profryder"].standingEyebrowsUp, musicStart:sexyJazz, loopTime:15000, musicSettings:[0.2, 3200]},
    {text:"Вы и так сегодня получили много опыта", emotion:characters["profryder"].standingSmiling},
    {text:"Можете попробовать снова, когда будете готовы", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Стейси, ты как?", emotion:characters["profryder"].standingEyebrowsUp},

  ]
  },
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
	{text:"Ну..."},
    {text:"Вообще, мне бы хотелось.. эм... кончить... но"},
    {text:"Ладно"},
    {text:"<small><i>думаю, я просто закончу... сама</small></i>"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Отличная идея, Стейси! Ахах", emotion:characters["profryder"].standingLaughing},
    {text:"Ричард, думаю, ты мог бы поступить так же..", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
  phrases:[
    {text:"Ой!", emotion:characters["dick"].neutral},
    {text:"...", emotion:characters["dick"].embarassed, soundEffect:boner, soundEffectVolume:0.3},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Смотрю, тебе тоже понравилось!", emotion:characters["profryder"].standingBlushed},
    {text:"Вы оба сегодня хорошо постарались!", emotion:characters["profryder"].standingSmiling},
    {text:"Это был ваш первый опыт, да еще и на глазах у всего класса... Как минимум ЭТО могло помешать", emotion:characters["profryder"].standingNeutral},
    {text:"Так что не волнуйтесь, вы получили опыт и, надеюсь, удовольствие!", emotion:characters["profryder"].standingLaughing},
    {text:"Ладно, ребята, можете садиться на места", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 70, speed:1,
  phrases:[
    {text:"*Звонок*", soundEffect:bellRinging, soundEffectVolume:0.2},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Ох, кажется пора кончать!", emotion:characters["profryder"].standingNeutral},
    {text:"На сегодня все!", emotion:characters["profryder"].standingSmiling},
    {text:"Пожалуйста, запишите домашнее задание!", emotion:characters["profryder"].standingSmiling},
    {text:"Поисследуйте свое тело, найдите то, что нравится именно вам", emotion:characters["profryder"].standingSmiling},
    {text:"Не бойтесь эксперементировать!", emotion:characters["profryder"].standingLaughing},
    {text:"Можете одни или с кем-то", emotion:characters["profryder"].standingSmiling},
    {text:"И будьте готовы поделиться вашим опытом на следующем занятии", emotion:characters["profryder"].standingSmiling},
    {text:"Увидимся!", emotion:characters["profryder"].standingLaughing, setNextStep:3}
  ]
  },
  {option:"Думаю, для первого раза хватит..", endOfOption:true, endOfOptions:true},
  {endOfNovel:true}
  ]},

  //Устал
  {novel:true, background:stacyOnTableArousedLeftBG, startCoordinates:20,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Блин, извини...", emotion:characters["dick"].frustrated, ambientStart:classroomAbmient, loopTimeAmbient:500, ambientSettings:[0.5, 1200]},
      {text:"Рука очень устает...", emotion:characters["dick"].frustrated},
    ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"Да, понимаю", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Не переживай, это нормально", emotion:characters["profryder"].standingLaughing},
      {text:"Особенно для первого раза", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Через какое-то время ты привыкнешь", emotion:characters["profryder"].standingSmiling},
      {text:"У девушек часто возникает такая же проблема когда они стимулируют... пенис", emotion:characters["profryder"].standingLaughing},
      {text:"Постарайся слушать Стейси, но и не забывай регулировать скорость так, чтобы не уставать слишком сильно!", emotion:characters["profryder"].standingSmiling},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"...", emotion:characters["dick"].frustrated, answers:["Хорошо!", "Кажется, на сегодня хватит"]},
    ]
  },

  {option:"Хорошо!", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
  phrases:[
    {text:"Хорошо!", emotion:characters["dick"].smiling},
    {text:"Давай попробуем еще?", emotion:characters["dick"].frustrated},
  ]
},
{char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
phrases:[
  {text:"Да..."},
  {text:"Все нормально, я понимаю.. хи-хи"},
  {text:"Давай попробуем", setNextStep:-2, lastTry:4},
  {text:"Но, знаешь, если я делаю это слишком долго, мне становится больно"},
  {text:"Так что, давай это будет последняя попытка, хорошо?", setNextStep:-2},
]
},
  {option:"Хорошо!", endOfOption:true},


  {option:"Кажется, на сегодня хватит", start:true},
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5],
  phrases:[
    {text:"Думаю, для первого раза, наверное хватит..", emotion:characters["dick"].frustrated},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Понимаю", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Абсолютно нормально сделать перерыв", emotion:characters["profryder"].standingEyebrowsUp, musicStart:sexyJazz, loopTime:15000, musicSettings:[0.2, 3200]},
    {text:"Вы и так сегодня получили много опыта", emotion:characters["profryder"].standingSmiling},
    {text:"Можете попробовать снова, когда будете готовы", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Стейси, ты как?", emotion:characters["profryder"].standingEyebrowsUp},

  ]
  },
  {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
  phrases:[
	{text:"Ну..."},
    {text:"Вообще, мне бы хотелось.. эм... кончить... но"},
    {text:"Ладно"},
    {text:"<small><i>думаю, я просто закончу... сама</small></i>"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Отличная идея, Стейси! Ахах", emotion:characters["profryder"].standingLaughing},
    {text:"Ричард, думаю, ты мог бы поступить так же..", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
  phrases:[
    {text:"Ой!", emotion:characters["dick"].neutral},
    {text:"...", emotion:characters["dick"].embarassed, soundEffect:boner, soundEffectVolume:0.3},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
  phrases:[
    {text:"Смотрю, тебе тоже понравилось!", emotion:characters["profryder"].standingBlushed},
    {text:"Вы оба сегодня хорошо постарались!", emotion:characters["profryder"].standingSmiling},
    {text:"Это был ваш первый опыт, да еще и на глазах у всего класса... Как минимум ЭТО могло помешать", emotion:characters["profryder"].standingNeutral},
    {text:"Так что не волнуйтесь, вы получили опыт и, надеюсь, удовольствие!", emotion:characters["profryder"].standingLaughing},
    {text:"Ладно, ребята, можете садиться на места", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 70, speed:1,
  phrases:[
    {text:"*Звонок*", soundEffect:bellRinging, soundEffectVolume:0.2},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
  phrases:[
    {text:"Ох, кажется пора кончать!", emotion:characters["profryder"].standingNeutral},
    {text:"На сегодня все!", emotion:characters["profryder"].standingSmiling},
    {text:"Пожалуйста, запишите домашнее задание!", emotion:characters["profryder"].standingSmiling},
    {text:"Поисследуйте свое тело, найдите то, что нравится именно вам", emotion:characters["profryder"].standingSmiling},
    {text:"Не бойтесь эксперементировать!", emotion:characters["profryder"].standingLaughing},
    {text:"Можете одни или с кем-то", emotion:characters["profryder"].standingSmiling},
    {text:"И будьте готовы поделиться вашим опытом на следующем занятии", emotion:characters["profryder"].standingSmiling},
    {text:"Увидимся!", emotion:characters["profryder"].standingLaughing, setNextStep:3}
  ]
  },
  {option:"Кажется, на сегодня хватит", endOfOption:true, endOfOptions:true},
  {endOfNovel:true}
  ]},

  //Без оргазма
  {novel:true, background:stacyOnTableArousedBG, startCoordinates:50,
  script:[
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true,
    phrases:[
      {text:"Уф-ф... блин, нет, не получается...", ambientStart:classroomAbmient, loopTimeAmbient:500, ambientSettings:[0.5, 1200]},
      {text:"Давай на сегодня все, я устала"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"Ничего страшного! Давайте закончим практику на сегодня", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"Как минимум ты сильно возбудилась, а это уже не мало!", emotion:characters["profryder"].standingBlushed, musicStart:sexyJazz, loopTime:15000, musicSettings:[0.2, 3200]},
      {text:"Хо-хо, я смотрю не только ты!", emotion:characters["profryder"].standingBlushed},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"..?", emotion:characters["dick"].neutralCame},
      {text:"Ой! Извините..", emotion:characters["dick"].frustratedCame, soundEffect:boner, soundEffectVolume:0.3},
      {text:"Я... ээ..", emotion:characters["dick"].frustratedCame, achievement:achievements[12]},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"Это совершенно нормальная реакция! Тут не за что извиняться", emotion:characters["profryder"].standingLaughing},
      {text:"Как я и говорила, обычно мужчинам гораздо легче достичь оргазма, чем женщинам", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"И если вы сильно возбудились, это может произойти даже без стимуляции", emotion:characters["profryder"].standingBlushed},
      {text:"Ну, где влажные салфетки вы знаете", emotion:characters["profryder"].standingSmiling},
      {text:"Кстати говоря, вопрос на засыпку, какие железы выделяют смазку у женщин?", emotion:characters["profryder"].standingQuestion, answers:["Малые вестибулярные железы", "Большие вестибулярные железы"]},
    ]
    },

    //Малые вестибулярные железы
    {option:"Большие вестибулярные железы", start:true},
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Верно!", emotion:characters["profryder"].standingEyebrowsUp, achievement:achievements[13]},
      {text:"Молодец!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Большие вестибулярные железы", endOfOption:true},
    //Большие вестибулярные железы
    {option:"Малые вестибулярные железы", start:true},
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, noBlur: true, destinationPoint:[0,-5,0,-5], changeBGTransition:stacyOnTableArousedLeftBG,
    phrases:[
      {text:"Э-э-э малы...", emotion:characters["dick"].frustratedCame},
    ]
    },
    {char:characters["stacy"],  position:"center", coordinates: 50, speed:1, noBlur: true, changeBGTransition:stacyOnTableArousedBG,
    phrases:[
      {text:"БОЛЬШИЕ вестибулярные железы!"},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5], changeBGTransition:stacyOnTableArousedRightBG,
    phrases:[
      {text:"Хахахах, правильно!", emotion:characters["profryder"].standingLaughing},
      {text:"Молодцы, командный дух, так держать!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Малые вестибулярные железы", endOfOption:true, endOfOptions:true},

    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
      {text:"Вы оба сегодня молодцы! Спасибо!", emotion:characters["profryder"].standingSmiling},
      {text:"Это был ваш первый опыт, да еще и на глазах у всего класса... Как минимум ЭТО могло помешать", emotion:characters["profryder"].standingNeutral},
      {text:"Так что не волнуйтесь, вы получили опыт и, надеюсь, удовольствие!", emotion:characters["profryder"].standingLaughing},
      {text:"Ладно, ребята, можете садиться на места, я чуть позже тут приберусь", emotion:characters["profryder"].standingEyebrowsUp},
    ]
  },
      {char:characters["empty"],  position:"center", coordinates: 70, speed:1,
    phrases:[
      {text:"*Звонок*", soundEffect:bellRinging, soundEffectVolume:0.2},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 70, noBlur: true, speed:1, destinationPoint:[-15,-5,-15,-5],
    phrases:[
	{text:"Ох, кажется пора кончать!", emotion:characters["profryder"].standingNeutral},
    {text:"На сегодня все!", emotion:characters["profryder"].standingSmiling},
    {text:"Пожалуйста, запишите домашнее задание!", emotion:characters["profryder"].standingSmiling},
    {text:"Поисследуйте свое тело, найдите то, что нравится именно вам", emotion:characters["profryder"].standingSmiling},
    {text:"Не бойтесь эксперементировать!", emotion:characters["profryder"].standingLaughing},
    {text:"Можете одни или с кем-то", emotion:characters["profryder"].standingSmiling},
    {text:"И будьте готовы поделиться вашим опытом на следующем занятии", emotion:characters["profryder"].standingSmiling},
    {text:"Увидимся!", emotion:characters["profryder"].standingLaughing}
    ]
    },
    {endOfNovel:true}
  ]},

  {blackScreen:true, txt:["<h2>*Пару минут спустя*</h2>"]},

  //Без оргазма
  {novel:true, background:wipingDeskBG, startCoordinates:50,
  script:[
    {char:characters["willie"],  position:"left", coordinates: 0, speed:3, noBlur: true, transitionMode:"slow",
    phrases:[
      {text:"Ну че как?", emotion:characters["willie"].snide, gallery:gallery[19], ambientStart:indoorCrowd, startPointAmbient:10, loopTimeAmbient:200, ambientSettings:[0.1, 1200], musicStart:classIntro, loopTime:30000, musicSettings:[0.2, 2200]},
      {text:"Каково это?", emotion:characters["willie"].neutral},
      {text:"Делать это по-настоящему?", emotion:characters["willie"].neutral},
    ]
    },
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Да видно же, что ему понравилось ахах!", emotion:characters["phoebe"].sittingLaughingCoffee},
    ]
    },
    {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
    phrases:[
      {text:"Ну дааа... Я тоже заметил хе-хе", emotion:characters["willie"].neutral},
      {text:"Ну что, пойдем?", emotion:characters["willie"].watchingPhone},
    ]
    },
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Ой, я бы с радостью", emotion:characters["phoebe"].sittingNeutralCoffee},
      {text:"Но мне.. мне нужно задержаться ненадолго", emotion:characters["phoebe"].sittingNeutralCoffee},
      {text:"Я думаю, я вас догоню", emotion:characters["phoebe"].sittingSmilingCoffee, answers:["Все хорошо?", "Ладно, пока!"]},
    ]
    },

    //Все хорошо?
    {option:"Все хорошо?", start:true},
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Да-да!", emotion:characters["phoebe"].sittingSmilingCoffee},
      {text:"Просто хотела спросить мисс Райдер кое о чем...", emotion:characters["phoebe"].sittingThinkingBlushedCoffee},
    ]
    },
    {option:"Все хорошо?", endOfOption:true},

    //Ладно, пока!
    {option:"Ладно, пока!", start:true},
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Пока-пока!", emotion:characters["phoebe"].sittingSmilingCoffee},
    ]
    },
    {option:"Ладно, пока!", endOfOption:true, endOfOptions:true},

    {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
    phrases:[
      {text:"Тогда увидимся завтра?", emotion:characters["willie"].neutral},
    ]
    },
    {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
    phrases:[
      {text:"Ага, до завтра!", emotion:characters["phoebe"].sittingSmilingCoffee},
    ]
    },
    {char:characters["profryder"],  position:"center", coordinates: 20, speed:1, transitionMode:"slow",
    phrases:[
      {text:"До свидания, ребята!", musicEnd:true, musicSettings:1500},
      {text:"И не забудьте про домашнее задание!", setNextStep:4},
    ]
    },
    {endOfNovel:true}
  ]},

  //ОРГАЗМ
  {novel:true, background:classroomMainCutAfterOrgasm, startCoordinates:20,
  script:[
    {scene:true, img:stacyAfterOrgasm, start:true, time:300, gallery:gallery[18], ambientStart:classroomAbmient, loopTimeAmbient:500, ambientSettings:[0.5, 1200]},
    {scene:true, name:characters["stacy"].nameRu, position:"center",
    phrases:[
      {text:"Ф-у-уф.."},
      {text:"<small><i>Это что был... сквирт?</small></i>"},
      {text:"Я вся мокрая..."},
    ]},
    {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[-7,-5,-7,-5],
    phrases:[
      {text:"Ахха и не ты одна!", emotion:characters["profryder"].standingLaughing, musicStart:sexyJazz, loopTime:15000, musicSettings:[0.2, 3200]},
      {text:"Ричард, иди сюда, давай дадим Стейси немного пространства", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, destinationPoint:[0,-10,0,-10],
    phrases:[
      {text:"..?", emotion:characters["dick"].neutralCame},
      {text:"Ой! Извините..", emotion:characters["dick"].frustratedCame, soundEffect:boner, soundEffectVolume:0.3},
      {text:"Я... ээ..", emotion:characters["dick"].frustratedCame, achievement:achievements[12]},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[-7,-5,-7,-5],
    phrases:[
      {text:"Это совершенно нормальная реакция! Тут не за что извиняться", emotion:characters["profryder"].standingLaughing},
      {text:"Как я и говорила, обычно мужчинам гораздо легче достичь оргазма, чем женщинам", emotion:characters["profryder"].standingSmiling},
      {text:"И если вы сильно возбудитесь, это может произойти даже без стимуляции", emotion:characters["profryder"].standingBlushed},
      {text:"Ну, где влажные салфетки вы знаете", emotion:characters["profryder"].standingBlushed},
      {text:"Ой, и да, Стейси, кажется ты эм-м...", emotion:characters["profryder"].standingSurprised},
      {text:"Эякулировала...", emotion:characters["profryder"].standingBlushed},
      {text:"Кстати говоря, вопрос на засыпку, какие железы ответственны за сквирт?", emotion:characters["profryder"].standingQuestion, answers:["Малые вестибулярные железы", "Большие вестибулярные железы"]}
 ]
    },

    //Большие вестибулярные железы
    {option:"Большие вестибулярные железы", start:true},
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Больш...", emotion:characters["dick"].frustratedCameSquirt},
    ]
    },
    {char:characters["stacy"],  position:"center", coordinates: 30, speed:1,
    phrases:[
      {text:"МАЛЫЕ вестибулярные железы!"},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 30, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Спасибо, Стейси!", emotion:characters["dick"].smilingCameSquirted},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Хахаха, правильно!", emotion:characters["profryder"].standingLaughing},
      {text:"Командный дух, так держать!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Большие вестибулярные железы", endOfOption:true},

    //Малые вестибулярные железы
    {option:"Малые вестибулярные железы", start:true},
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Правильно!", emotion:characters["profryder"].standingEyebrowsUp, achievement:achievements[13]},
      {text:"Молодец!", emotion:characters["profryder"].standingLaughing},
    ]
    },
    {option:"Малые вестибулярные железы", endOfOption:true, endOfOptions:true},

    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Вы оба сегодня отлично поработали! Честно говоря, я не ожидала такого результата!", emotion:characters["profryder"].standingLaughing},
      {text:"Ввиду нашего эм-м.. окончания, хочу напомнить, что достичь оргазма с первого раза получается не всегда, и это нормально!", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"И если у вас есть какие-нибудь сложности, всегда можете обратиться ко мне!", emotion:characters["profryder"].standingSmiling},
      {text:"Ладно, ребята, теперь можете садиться на места, я попозже все вытру", emotion:characters["profryder"].standingSmiling},

    ]
    },
    {char:characters["empty"],  position:"center", coordinates: 50, speed:1,
    phrases:[
      {text:"*Звонок*", soundEffect:bellRinging, soundEffectVolume:0.2},
    ]
    },
    {char:characters["profryder"],  position:"right", coordinates: 50, speed:1, destinationPoint:[0,-5,0,-5],
    phrases:[
      {text:"Ой, кажется, нам пора кончать!", emotion:characters["profryder"].standingEyebrowsUp},
      {text:"На сегодня все!", emotion:characters["profryder"].standingSmiling},
      {text:"Пожалуйста, запишите домашнее задание!", emotion:characters["profryder"].standingSmiling},
      {text:"Поисследуйте свое тело, найдите то, что нравится именно вам", emotion:characters["profryder"].standingSmiling},
      {text:"Не бойтесь эксперементировать!", emotion:characters["profryder"].standingLaughing},
      {text:"Можете одни или с кем-то", emotion:characters["profryder"].standingSmiling},
      {text:"И будьте готовы поделиться вашим опытом на следующем занятии", emotion:characters["profryder"].standingSmiling},
      {text:"Увидимся!", emotion:characters["profryder"].standingLaughing}

    ]
    },
    {endOfNovel:true}
]},

{blackScreen:true, txt:["<h2>*Пару минут спустя*</h2>"]},

{novel:true, background:wipingDeskBG, startCoordinates:50,
script:[
  {char:characters["willie"],  position:"left", coordinates: 0, speed:3, noBlur: true, transitionMode:"slow",
  phrases:[
    {text:"Чуваак, это было мега-круто!!!", emotion:characters["willie"].neutralSquirt, gallery:gallery[19], ambientStart:indoorCrowd, startPointAmbient:10, loopTimeAmbient:200, ambientSettings:[0.1, 1200], musicStart:classIntro, loopTime:30000, musicSettings:[0.2, 2200]},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Ага-а-а...", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"Мне кажется, даже на меня немного попало!!", emotion:characters["willie"].neutralSquirt},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Это от Стейси или... от Дика? Ахаха", emotion:characters["phoebe"].sittingSnideCoffee},
    {text:"Оо! Теперь у нас у всех мокрые кофты! Круто!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"Ага! Мы теперь КОМАНДА ВЛАЖНЫХ!!! Ахах", emotion:characters["willie"].neutralSquirt, achievement:achievements[14]},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Ага.. тогда уж CUMанда!", emotion:characters["phoebe"].sittingThinkingCoffee},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"Да-да-да!", emotion:characters["willie"].neutralSquirt},
    {text:"Нуу что...", emotion:characters["willie"].watchingPhoneSquirt},
    {text:"Пойдем?", emotion:characters["willie"].neutralSquirt},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Ой, я бы с радостью", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"Но мне.. мне нужно задержаться ненадолго", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"Я думаю, я вас догоню", emotion:characters["phoebe"].sittingSmilingCoffee, answers:["Все хорошо?", "Ладно, пока!"]},
]
  },

  //Все хорошо?
  {option:"Все хорошо?", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Да-да!", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"Просто хотела спросить мисс Райдер кое о чем...", emotion:characters["phoebe"].sittingThinkingBlushedCoffee},
  ]
  },
  {option:"Все хорошо?", endOfOption:true},

  //Ладно, пока!
  {option:"Ладно, пока!", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Пока-пока!", emotion:characters["phoebe"].sittingSmilingCoffee},
  ]
  },
  {option:"Ладно, пока!", endOfOption:true, endOfOptions:true},

  {char:characters["willie"],  position:"left", coordinates: 0, speed:1, noBlur: true,
  phrases:[
    {text:"Тогда увидимся завтра?", emotion:characters["willie"].neutralSquirt},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 40, speed:1, destinationPoint:[-10,-2,-10,-2], noBlur: true,
  phrases:[
    {text:"Ага, до завтра!", emotion:characters["phoebe"].sittingSmilingCoffee},
  ]
  },
  {char:characters["profryder"],  position:"center", coordinates: 20, speed:1, transitionMode:"slow",
  phrases:[
    {text:"До свидания, ребята!", musicEnd:true, musicSettings:1500},
    {text:"И не забудьте про домашнее задание!"},
  ]
  },

  {endOfNovel:true}
]},

{blackScreen:true, txt:["<h2>*Вечером того же дня*</h2>"]},

{groupChat:true, from:{name:"53X группа", photo:chatCover, members:8},
 messages: [
   {text:"Ооооо даааа... То что вода холодненькая ЭТО Я ВИЖУ!!",from:'messageFromThem', name:"HwrD", avatar:howardChat},
   {img:ryderInsta, height:"450px", from:'messageFromThem', name:"HwrD", avatar:howardChat, gallery:gallery[20]},
   {text:"Дашь ссылку?",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Неееет это только для личного пользования",from:'messageFromThem', name:"HwrD", avatar:howardChat},
   {text:"Ребята, ну хватит!",from:'messageFromThem', name:"Stacy♡", avatar:stacyChat},
   {text:"Вы вообще хоть кого-нибудь уважаете, хотя бы себя?",from:'messageFromThem', name:"Stacy♡", avatar:stacyChat},
   {notification:"Приветик! Спишь?", vibration:[300], name:"Фиби", avatar:phoebeChat, endOfChat:true},
]
},

{blackScreen:true, txt:["<h2>Это конец второй главы! Надеюсь вам понравилось! </h2> <br/> Оставлйте отзывы в комментариях;)","<h2>Третья глава(Домашее задание) уже доступна на патреоне, там же вы найдете информацию о предстоящих обновлениях, WIPы, опросы и эксклюзивный контент!</h2>","<h2>Пожалуйста, поддержите меня, если у вас есть такая возможность! </h2> Ваша поддержка позволяет продолжать работу над игрой и делать ее лучше! </br> Спасибо!💖"], end:true},


];

export default chapter2ru;
